import {
  defineSchema,
  SchemaInstance,
} from "@redotech/redo-flows-core-schema-common/type-system/schema";

/**
 * Marketing Agent schema for AI-generated email content.
 * This schema has no template variables except unsubscribe links
 * since the AI generates fully-formed content.
 */
export const marketingAgentSchema = defineSchema({
  fields: {
    unsubscribeLink: {
      dataType: "Maybe Url",
      documentation:
        "The link to unsubscribe from email updates. Only displays when the customer is subscribed",
      hideFromInsertionModal: true,
    },
    oneClickUnsubscribeLink: {
      dataType: "Maybe Url",
      hideFromInsertionModal: true,
      documentation:
        "The link to unsubscribe from email updates with one click for email delivery compliance. Only displays when the customer is subscribed",
    },
  },
});

export const exampleMarketingAgentSchemaInstance: SchemaInstance<
  typeof marketingAgentSchema
> = {
  unsubscribeLink: "https://example.com/unsubscribe",
  oneClickUnsubscribeLink: "https://example.com/one-click-unsubscribe",
};
